export const handleCopyTextToClipboard = async (text: string): Promise<void> => {
  console.log("text >>> ", text);

  // if (navigator?.clipboard?.writeText) {
  //   console.log("run if >>> " );
  //   try {
  //     await navigator.clipboard.writeText(text);
  //     return;
  //   } catch (error) {
  //     console.log("error >>>>", error);
  //   }
  // }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.top = "-1000px";
  textarea.style.left = "-1000px";
  textarea.style.opacity = "0";
  textarea.setAttribute("readonly", "");

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const successful = (document as any).execCommand("copy");
    if (!successful) {
      throw new Error("execCommand('copy') returned false");
    }
  } catch (error) {
    console.log("error >>> ", error);
  } finally {
    document.body.removeChild(textarea);
  }
};
